<div class="layout-shell">
  <lib-header></lib-header>

  <main class="page-wrapper">
    <ng-content></ng-content>
  </main>
</div>
